// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Un7t","inner":"Footer_inner__OR5QW"};